import 'src/styles/globals.css';
import {
  ApolloClient,
  ApolloProvider,
  HttpLink,
  InMemoryCache,
} from '@apollo/client';
import { appWithTranslation } from 'next-i18next';
import { MantineProvider } from '@mantine/core';
import { NotificationsProvider } from '@mantine/notifications';
import { TourProvider } from 'context/TourContext';
import { LanguageProvider } from 'context/LanguageContext';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { CurrencyProvider } from 'context/CurrencyContext';
import Script from 'next/script';

function MyApp({ Component, pageProps }) {
  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: new HttpLink({
      uri: `/api/graphql`,
      fetch: async (uri, options) => {
        const response = await fetch(uri, {
          redirect: 'follow',
          ...options,
        });
        if (response.redirected) {
          window.location.href = response.url;
        }
        return response;
      },
    }),
  });

  const [cookies, setCookie] = useCookies(['lang']);

  useEffect(() => {
    if (!cookies.lang) {
      let lang = navigator.language.split('-')[0];
      // console.log('lang', lang);
      if (!lang) {
        return;
      }
      setCookie('lang', lang, { path: '/' });
    }
  }, []);

  const clarityCode = `
    (function (c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "ojia1c566z");`

    // Dev clarity code: ojia1c566z
    // Master clarity code: ojiax78qme

  return (
    <CurrencyProvider>
      <LanguageProvider>
        <TourProvider>
          <MantineProvider
            withGlobalStyles
            withNormalizeCSS
            theme={{
              /** Put your mantine theme override here */
              colorScheme: 'light',
            }}
          >
            <ApolloProvider client={client}>
              <NotificationsProvider>
                <Component {...pageProps} />
                <div id="portal" style={{position:"fixed", top:"0", zIndex:9999}}></div>
                <Script id="ms-clarity" strategy="afterInteractive">
                  {clarityCode}
                </Script>
              </NotificationsProvider>
            </ApolloProvider>
          </MantineProvider>
        </TourProvider>
      </LanguageProvider>
    </CurrencyProvider>
  );
}

export default appWithTranslation(MyApp);
